import { render, staticRenderFns } from "./MenuSidebar.vue?vue&type=template&id=10aa828d&"
import script from "./MenuSidebar.vue?vue&type=script&lang=js&"
export * from "./MenuSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports